export default __webpack_public_path__ + "static/media/prt-binance.1a7da89b.svg";